<!--
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
-->
<div class="wsn-container">
  <wsn-navbar-wrapper [showOptions]="false"></wsn-navbar-wrapper>
  <div class="main-layout container-fluid p-0 h-100 d-flex flex-column">
    <div class="login-content d-flex justify-content-center">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
